import React, { useState } from 'react';
import './LocationHeader.css';

const images = [
  '/images/cafe-image.jpg',
  'https://images.unsplash.com/photo-1567880905822-56f8e06fe630?w=600&h=400&fit=crop',
  'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=600&h=400&fit=crop',
  'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&h=400&fit=crop',
  'https://images.unsplash.com/photo-1537047902294-62a40c20a6ae?w=600&h=400&fit=crop',
];

const LocationHeader = () => {
  const [showGallery, setShowGallery] = useState(false);

  return (
    <>
      <div className="location-hero">
        <div className="hero-grid">
          <div className="hero-main">
            <img src={images[0]} alt="Cozy Baby Cafe - Main" className="hero-image hero-image--main" />
          </div>
          <div className="hero-secondary">
            <img src={images[1]} alt="Cozy Baby Cafe" className="hero-image" />
            <img src={images[2]} alt="Cozy Baby Cafe" className="hero-image" />
            <img src={images[3]} alt="Cozy Baby Cafe" className="hero-image hero-image--corner-tr" />
            <img src={images[4]} alt="Cozy Baby Cafe" className="hero-image hero-image--corner-br" />
          </div>
        </div>

        <div className="hero-actions">
          <button className="hero-action-btn">
            <span>📤</span> Share
          </button>
          <button className="hero-action-btn">
            <span>🤍</span> Save
          </button>
        </div>

        <button className="show-all-photos-btn" onClick={() => setShowGallery(true)}>
          <span>📷</span> Show all photos
        </button>
      </div>

      {showGallery && (
        <div className="gallery-modal" onClick={() => setShowGallery(false)}>
          <div className="gallery-modal__content" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-close-btn" onClick={() => setShowGallery(false)}>✕</button>
            <div className="gallery-grid">
              {images.map((img, idx) => (
                <img key={idx} src={img} alt={`Cozy Baby Cafe ${idx + 1}`} className="gallery-image" />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LocationHeader;
